module.exports = __webpack_public_path__ + "static/img/manual-28.5b7ec46.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-28.png
// module id = e6Uv
// module chunks = 4